// Add fetch_status to initial state
export const State = {
    init_state: "",
    
    // Add fetch status object
    fetch_status: {
      status: 'idle', // 'idle', 'loading', 'success', 'failed'
      action: null,
      error: null
    }
  }